import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { OrganizationAdminService } from '../../services/organization-admin.service';
import { MatDialog } from '@angular/material/dialog';
import { INT_PLANS } from '../../../../shared/constants/int_plans';

@Component({
  selector: 'app-org-create',
  templateUrl: './org-create.component.html',
  styleUrls: ['./org-create.component.css']
})
export class OrgCreateComponent implements OnInit {
 /** USING THIS TO RESET FORM  WITH OUT SHOWING FORMVALIDAITON ERRORS**/
 @ViewChild('myForm', {static: false}) myForm: NgForm;

  orgForm:FormGroup;
  public isShowAlert:boolean= false;

  public int_plans = INT_PLANS;

  constructor(private fb:FormBuilder,
    private dialog: MatDialog,
    private orgService:OrganizationAdminService) { }

  ngOnInit(): void {
    this.createOrgForm();
  }

  createOrgForm(){
    this.orgForm = this.fb.group({
      name: ['',[Validators.required]],
      int_plan_id: ['',[Validators.required]],
      onboarding_type: ['1']
    })
  }

  get orgFormValidate(){
    return this.orgForm.controls;
  }

  orgFormSubmit(){
    if(this.orgForm.invalid){
      return;
    }
    this.orgService.createOrganization(this.orgForm.value).subscribe(
      (res)=>{
        this.orgForm.reset();
        this.myForm.resetForm();
        this.isShowAlert= true;
        this.closeAlertMessage();
        this.createOrgForm();
      }
    )
    console.log(this.orgForm.value);
  }

  cancel():void{
    this.dialog.closeAll();
  }

  closeAlertMessage(){
    setTimeout(()=>{
      this.isShowAlert=false;
    },5000);
  }

}
